import type { Rule, RuleObject } from 'antd/es/form';
import type { LabelInValue } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { OrganizationOption } from '../../video-basic-info-form-content';

export const useTagsRules = (): Rule[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      ({ getFieldValue }) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
        const organization: OrganizationOption | undefined = getFieldValue('organization');

        return {
          message: t('Error: Selected tags are not valid for current organization'),
          // eslint-disable-next-line @typescript-eslint/require-await -- antd interface
          async validator(_: RuleObject, values?: LabelInValue[]) {
            const organizationTagsIds = new Set(organization?.tags.map((tag) => tag.id));

            if (values && !values.every((tag) => organizationTagsIds.has(tag.value))) {
              throw new Error('Error: Selected tags are not valid for current organization');
            }
          },
        };
      },
    ],
    [t],
  );
};
